import Component from '@glimmer/component';
import { service } from '@ember/service';
import { SystemNotifications, Notifications } from 'core/components';
import HcpMarketing from 'hcp/components/hcp-marketing';
import Main from 'hcp/components/page/sign-in/main';

/**
 *
 * `PageSignUp` renders the page for the sign-up route. There are two states for this page - the normal page that a user would seee before authenticating, and a page will different messaging that a user would encounter if they initially did the "sign-in" flow but didn't yet have an account on HCP.
 *
 *
 * ```
 * <Page::SignUp />
 * ```
 *
 * @class PageSignUp
 *
 */
export default class PageSignUp extends Component {
  @service router;

  signUp = () => {
    this.router.transitionTo('cloud');
  };

  <template>
    <SystemNotifications />
    <Notifications />
    <HcpMarketing data-test-page-sign-in ...attributes as |M|>
      <M.Main>
        <Main @error={{@error}} @isSignUpPage={{true}} />
      </M.Main>
      <M.Aside />
    </HcpMarketing>
  </template>
}
